<template>
  <div id="app" class="overflow-x-hidden">
    <!-- Global Navbar -->
    <AppNavbar />
    <router-view />
    <!-- Global Footer -->
    <AppFooter />
  </div>
</template>

<script>

import AppNavbar from "@/components/Navbar.vue";
import AppFooter from "@/components/Footer.vue";

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppFooter,
  },
};

</script>

<style>
/* Keep global styles here if needed */
</style>
